import { Controller } from "@hotwired/stimulus"

const REASON_STATUSES = ["rejected", "withdrawn"]
const INTAKE_STATUS = "intake"
const MODAL_STATUSES = [...REASON_STATUSES, INTAKE_STATUS]

export default class extends Controller {
  static targets = [
    "statusForm",
    "statusSelect",
    "modal",
    "nextStatus",
    "reasonSelect",
    "reasonLabel",
    "reasonFields",
    "intakeFields",
    "intakeDate",
    "intakeTime",
    "title",
    "note"
  ]
  static values = {
    rejectedReasons: Array,
    withdrawnReasons: Array,
    rejectedLabel: String,
    withdrawnLabel: String,
    rejectedTitle: String,
    withdrawnTitle: String,
    intakeTitle: String,
    reasonBlank: String
  }

  statusChanged() {
    const value = this.statusSelectTarget.value
    if (!value) return

    if (MODAL_STATUSES.includes(value)) {
      this.openModal(value)
      return
    }

    this.statusFormTarget.requestSubmit()
  }

  openModal(status) {
    this.nextStatusTarget.value = status
    this.titleTarget.textContent = this.titleFor(status)
    this.noteTarget.value = ""
    this.toggleFields(status)

    if (this.isIntake(status)) {
      this.reasonSelectTarget.value = ""
    } else {
      this.reasonLabelTarget.textContent = this.labelFor(status)
      this.populateReasons(status)
      this.clearIntakeFields()
    }

    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.statusSelectTarget.value = ""
    this.nextStatusTarget.value = ""
    this.noteTarget.value = ""
    this.reasonSelectTarget.value = ""
    this.clearIntakeFields()
    this.toggleFields("rejected")
  }

  toggleFields(status) {
    const intake = this.isIntake(status)

    this.reasonFieldsTarget.classList.toggle("hidden", intake)
    this.intakeFieldsTarget.classList.toggle("hidden", !intake)
    this.reasonSelectTarget.disabled = intake
    this.noteTarget.disabled = intake
    this.intakeDateTarget.disabled = !intake
    this.intakeTimeTarget.disabled = !intake
    this.reasonSelectTarget.required = !intake
  }

  clearIntakeFields() {
    this.intakeDateTarget.value = ""
    this.intakeTimeTarget.value = ""
  }

  isIntake(status) {
    return status === INTAKE_STATUS
  }

  populateReasons(status) {
    const reasons = status === "rejected" ? this.rejectedReasonsValue : this.withdrawnReasonsValue
    this.reasonSelectTarget.replaceChildren()

    const blank = document.createElement("option")
    blank.value = ""
    blank.textContent = this.reasonBlankValue
    this.reasonSelectTarget.appendChild(blank)

    reasons.forEach(([label, key]) => {
      const option = document.createElement("option")
      option.value = key
      option.textContent = label
      this.reasonSelectTarget.appendChild(option)
    })
  }

  titleFor(status) {
    if (status === "rejected") return this.rejectedTitleValue
    if (status === "withdrawn") return this.withdrawnTitleValue
    return this.intakeTitleValue
  }

  labelFor(status) {
    return status === "rejected" ? this.rejectedLabelValue : this.withdrawnLabelValue
  }
}
